const PAYMENT_CREATED = 'paymentCreated'
const PAYMENT_UPDATED = 'paymentUpdated'
const PAYMENT_APPROVED = 'paymentApproved'
const BANK_TRANSACTION_CREATED = 'bankTransactionCreated'
const BANK_TRANSACTION_UPDATED = 'bankTransactionUpdated'
const REPORT_GENERATED = 'reportGenerated'

export {
    PAYMENT_CREATED,
    PAYMENT_UPDATED,
    PAYMENT_APPROVED,
    BANK_TRANSACTION_CREATED,
    BANK_TRANSACTION_UPDATED,
    REPORT_GENERATED,
}
